import React, { createContext, useContext, useState, useEffect } from "react";

const SelectedTabContext = createContext();

export const SelectedTabProvider = ({ children }) => {
  const [selectedNavigationTab, setSelectedNavigationTab] = useState(
    localStorage.getItem("selectedTab") || "main"
  );

  useEffect(() => {
    localStorage.setItem("selectedTab", selectedNavigationTab);
  }, [selectedNavigationTab]);

  return (
    <SelectedTabContext.Provider
      value={{ selectedNavigationTab, setSelectedNavigationTab }}
    >
      {children}
    </SelectedTabContext.Provider>
  );
};

export const useSelectedTab = () => useContext(SelectedTabContext);
